import startCase from "lodash/startCase";

/**
 * @param {i18n} i18n from useI18n
 * @param {string} localeKey key to the translation
 * @param {string} fallback fallback string in case translation doesn't exist
 * @description Returns the i18n translation if it exists. Otherwise, returns the fallback string if it exists. Otherwise, returns the last part of the localeKey, Title Cased.
 */
export default (
  i18n: any,
  localeKey: string,
  fallback?: string,
  params?: any,
): string => {
  const localeKeyLastPart = localeKey.split(".").pop(); // "product.description.heading" --> "heading"

  return i18n.te(localeKey)
    ? i18n.t(localeKey, params)
    : fallback || startCase(localeKeyLastPart);
};
